import { Option } from './option';
export enum DaysOfWeekEnum {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

export namespace DaysOfWeekEnum {
    export function getOptions(): Option<DaysOfWeekEnum>[] {
        return [
            { name: 'Mon', value: DaysOfWeekEnum.MONDAY },
            { name: 'Tue', value: DaysOfWeekEnum.TUESDAY },
            { name: 'Wed', value: DaysOfWeekEnum.WEDNESDAY },
            { name: 'Thu', value: DaysOfWeekEnum.THURSDAY },
            { name: 'Fri', value: DaysOfWeekEnum.FRIDAY },
            { name: 'Sat', value: DaysOfWeekEnum.SATURDAY },
            { name: 'Sun', value: DaysOfWeekEnum.SUNDAY },
        ]
    }
}